import React from "react";
import { useNavigate } from "react-router-dom";
import "./Logo.scss";
import BelegoIcon from "../BelegoIcon";

export type LogoVariant = "nav" | "footer" | "auth" | "default";

interface LogoProps {
  variant?: LogoVariant;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
}



export default function Logo({ variant = "default", className = "", onClick }: LogoProps) {
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (onClick) {
      onClick(e);
      return;
    }

    if (variant === "auth" || variant === "default") {
      navigate("/");
    } else if (variant === "nav" || variant === "footer") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const baseClass =
    variant === "footer"
      ? "f-logo"
      : variant === "auth"
        ? "auth-logo"
        : "nav-logo";
  const cls = [baseClass, className].filter(Boolean).join(" ");

  const markClass =
    variant === "footer"
      ? "f-logo-mark"
      : variant === "auth"
        ? "auth-logo-mark"
        : "logo-mark";

  const innerContent = (
    <>
      <div className={markClass}>
        <BelegoIcon />
      </div>
      <span className="logo-name">
        Konto<span>Match</span>
      </span>
    </>
  );

  if (variant === "footer" || variant === "auth") {
    const Tag = variant === "footer" ? "div" : "a";
    return (
      <Tag
        href={variant === "auth" ? "/" : undefined}
        className={cls}
        onClick={handleClick}
        style={{ cursor: "pointer", textDecoration: "none" }}
      >
        {innerContent}
      </Tag>
    );
  }

  return (
    <a href="/" className={cls} onClick={handleClick}>
      {innerContent}
    </a>
  );
}